import "react-id-swiper/src/styles/css/swiper.css";

import * as React from "react";
import Swiper from "react-id-swiper";
import { withStyles, WithStyles } from "@material-ui/core";
import { styles } from "./HomeSwiper.style";

const swiperParams = {
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }

};

interface HomeSwiperProps {
    slides?: number;
}

class HomeSwiper extends React.Component<HomeSwiperProps & WithStyles<typeof styles>> {

    swiper = null;

    goNext() {
        if (this.swiper) {
            this.swiper.slideNext();
        }
    }

    goPrev() {
        if (this.swiper) {
            this.swiper.slidePrev();
        }
    }

    public render() {

        const classes = this.props.classes;

        return (
            <div className={classes.swiper}>
                <Swiper
                    {...swiperParams}
                    // TODO: @all - default value?
                    slidesPerView={this.props.slides}
                    ref={node => (node && node.swiper) ? this.swiper = node.swiper : null}
                    shouldSwiperUpdate={true}
                >
                    {this.props.children}
                </Swiper>
                <button className={[classes.nav, classes.navPrev].join(" ")} onClick={() => this.goPrev()}/>
                <button className={[classes.nav, classes.navNext].join(" ")} onClick={() => this.goNext()}/>
            </div>
        );
    }

}

export default withStyles(styles)(HomeSwiper);


// WEBPACK FOOTER //
// ./src/components/HomeSwiper/HomeSwiper.tsx